
const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Profesionalidad',
      description: 'Equipo altamente cualificado con más de 15 años de experiencia en el sector de vaciado y limpieza extrema',
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Discreción',
      description: 'Máxima confidencialidad en todos nuestros servicios, especialmente en casos delicados como el síndrome de Diógenes',
    },
    {
      icon: 'ri-time-line',
      title: 'Rapidez',
      description: 'Servicio de urgencia disponible 24/7 con capacidad de respuesta inmediata en toda la comarca',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Empatía',
      description: 'Trato humano y respetuoso en situaciones difíciles, entendiendo las necesidades emocionales de cada caso',
    },
    {
      icon: 'ri-recycle-line',
      title: 'Sostenibilidad',
      description: 'Gestión responsable de residuos con reciclaje y donación de enseres en buen estado a entidades sociales',
    },
    {
      icon: 'ri-medal-line',
      title: 'Garantía',
      description: 'Compromiso de calidad con garantía total en todos nuestros servicios y satisfacción del cliente',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-graphite mb-4">
            Nuestros <span className="text-primary">valores</span>
          </h2>
          <p className="text-lg text-gray-medium max-w-2xl mx-auto">
            Los principios que guían nuestro trabajo diario y nos convierten en la empresa de confianza en Castelldefels
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-silver-light/30 rounded-2xl p-8 hover:shadow-card-hover hover:-translate-y-2 transition-all duration-300"
            >
              <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mb-6">
                <i className={`${value.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-graphite mb-3">{value.title}</h3>
              <p className="text-gray-dark leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
